import _ from 'lodash';
import Http from '../http';

const prefix = '/website';

var softCache = [];

const websiteViewsCache = {};

const websiteToolsConnectedCache = {};

const DEFAULT_TOOL_STATE = {
  connected: false,
};

const DEFAULT_TOOLS_CONNECTED = {
  builderall_socialproof: Object.assign({}, DEFAULT_TOOL_STATE),
  MailingBossFormComponent: Object.assign({}, DEFAULT_TOOL_STATE),
  BookingCalendarComponent: Object.assign({}, DEFAULT_TOOL_STATE),
};

const sumGraphDateViews = (dateData) => {
  if (!dateData) return 0;

  if (Array.isArray(dateData)) {
    return dateData.reduce((sum, value) => sum + (Number(value) || 0), 0);
  }

  if (typeof dateData === 'object') {
    return Object.values(dateData).reduce((sum, value) => sum + (Number(value) || 0), 0);
  }

  return 0;
};

const encodeDataToURL = data => {
  return Object.keys(data)
    .map(value => `${value}=${encodeURIComponent(data[value])}`)
    .join('&');
};

export const getDataGraphs = (website_id, page) => {
  return Http.authApi().get(`${prefix}/data/graphs/${website_id}?page=${page}`);
};

export const getWebsiteTotalViews = (website_id) => {
  if (websiteViewsCache[website_id] !== undefined) {
    return Promise.resolve(websiteViewsCache[website_id]);
  }

  return getDataGraphs(website_id, '')
    .then((response) => {
      const total = response.data && response.data.total !== undefined
        ? Number(response.data.total) || 0
        : sumGraphDateViews(response.data && response.data.date);

      websiteViewsCache[website_id] = total;
      return total;
    });
};

export const getCachedWebsiteTotalViews = (website_id) => {
  if (websiteViewsCache[website_id] === undefined) return null;

  return websiteViewsCache[website_id];
};

export const getWebsiteToolsConnected = (website_id) => {
  if (websiteToolsConnectedCache[website_id] !== undefined) {
    return Promise.resolve(websiteToolsConnectedCache[website_id]);
  }

  return Http.authApi().get(`${prefix}/data/tools-connected/${website_id}`)
    .then((response) => {
      const toolsConnected = {
        builderall_socialproof: Object.assign({}, DEFAULT_TOOL_STATE, response.data.builderall_socialproof || {}),
        MailingBossFormComponent: Object.assign({}, DEFAULT_TOOL_STATE, response.data.MailingBossFormComponent || {}),
        BookingCalendarComponent: Object.assign({}, DEFAULT_TOOL_STATE, response.data.BookingCalendarComponent || {}),
      };
      websiteToolsConnectedCache[website_id] = toolsConnected;
      return toolsConnected;
    });
};

export const getCachedWebsiteToolsConnected = (website_id) => {
  if (websiteToolsConnectedCache[website_id] === undefined) return null;

  return websiteToolsConnectedCache[website_id];
};

export const getDataAccess = website_id => {
  return Http.authApi().get(`${prefix}/data/access/${website_id}`);
};

export const getWebsites = (page_published = 1, page_unpublished = 1, filters = 0) => {
  return Http.authApi().get(
    `/my-websites-user?page_published=${page_published}&page_unpublished=${page_unpublished}&new_layout=1&${encodeDataToURL(filters)}&time=` + Date.now()
  );
};

export const getAllWebsites = (page_all = 1,  filters = 0, per_page = 12) => {
  return Http.authApi().get(`/get-websites-all?page_all=${page_all}&per_page=${per_page}&${encodeDataToURL(filters)}`);
};

export const getDashboardData = (period) => {
  return Http.authApi().get(`user/dashboard/numbers/${period}`);
};

export const getWebsitesAll = () => {
  return Http.authApi().get('/websites-all');
};

export const getAllUserWebsites = () => {
  return Http.authApi().get(
    `${prefix}s`
  );
};

export const get = website => {
  if (typeof website === 'object') {
    return Http.authApi().get(`${prefix}/${website.encrypted_id}`);
  }
  if (typeof website === 'string') {
    return Http.authApi().get(`${prefix}/${website}`);
  }
};

export const getSplitTest = website => {
  if (typeof website === 'object') {
    return Http.authApi().get(`${prefix}/data/split-tests/${website.encrypted_id}`);
  }
  if (typeof website === 'string') {
    return Http.authApi().get(`${prefix}/data/split-tests/${website}`);
  }
};

export const create = website => Http.authApi().post(`${prefix}`, website);

export const edit = website =>
  Http.authApi().put(`${prefix}/${website.encrypted_id}`, website);

export const editScripts = website =>
  Http.authApi().put(`${prefix}/config-scripts/${website.encrypted_id}`, {
    layout: _.omit(website.layout, ['footers', 'headers', 'pages', 'popups']),
    events: website.events
  });

export const editSeo = website =>
  Http.authApi().put(`${prefix}/config-seo/${website.encrypted_id}`, website);

export const exclude = website =>
  Http.authApi().delete(`${prefix}/${website.encrypted_id}`, website);

export const deletedWebsitesSelected = data =>
  Http.authApi().post(`${prefix}/delete-selected-websites`, data);

export const editCategories = website =>
  Http.authApi().put(`${prefix}/categories/${website.encrypted_id}`, website);

// Services
export const updateStatus = data =>
  Http.authApi().put(`${prefix}/${data.encrypted_id}/status`, data);

export const updateFavorite = data =>
  Http.authApi().put(`${prefix}/${data.encrypted_id}/favorite`, data);

export const duplicateWebsite = website =>
  Http.authApi().post(`duplicate${prefix}/${website.encrypted_id}`, website);

export const transferWebsite = (website, email) =>
  Http.authApi().post(`${prefix}/transfer/${website.encrypted_id}`, email);

export const transferDuplicateWebsite = (website, email) =>
  Http.authApi().post(
    `${prefix}/transfer/${website.encrypted_id}/duplicate`,
    email
  );

export const transferDuplicateTemplate = (website, email) =>
  Http.authApi().post(
    `${prefix}/transfer/${website.encrypted_id}/template`,
    email
  );

export const startAiTemplateGeneration = (data) =>
  Http.authApi().post(`/ai/generate-template`, data);

export const getAiTemplateGenerationStatus = (ai_log_id) =>
  Http.authApi().get(`/ai/generate-status/${ai_log_id}`);

export const importStaticWebsite = (formData) =>
  Http.authApi().post(`${prefix}/import-static`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const generateTexts = (message) =>
  Http.authApi().get(`/ai/generate-texts?message=${message}`);



// WEBPACK FOOTER //
// ./src/js/services/editor/website.js